module.exports = __webpack_public_path__ + "img/actors.e38c5a90.jpg";